module.exports = __webpack_public_path__ + "static/media/newLog.30601dce.jpeg";